'use strict';
import * as $j_app$002eapi$002e$002dGeneral$002dPractice$002dApp$002dUpdate$0024$002dChat$002dRead from "./app.api.-General-Practice-App-Update$-Chat-Read.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_api_GeneralPracticeAppUpdate$ChatRead$() {
}
export { $c_Lapp_api_GeneralPracticeAppUpdate$ChatRead$ as $c_Lapp_api_GeneralPracticeAppUpdate$ChatRead$ };
$c_Lapp_api_GeneralPracticeAppUpdate$ChatRead$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_api_GeneralPracticeAppUpdate$ChatRead$.prototype.constructor = $c_Lapp_api_GeneralPracticeAppUpdate$ChatRead$;
/** @constructor */
function $h_Lapp_api_GeneralPracticeAppUpdate$ChatRead$() {
}
export { $h_Lapp_api_GeneralPracticeAppUpdate$ChatRead$ as $h_Lapp_api_GeneralPracticeAppUpdate$ChatRead$ };
$h_Lapp_api_GeneralPracticeAppUpdate$ChatRead$.prototype = $c_Lapp_api_GeneralPracticeAppUpdate$ChatRead$.prototype;
$c_Lapp_api_GeneralPracticeAppUpdate$ChatRead$.prototype.toString__T = (function() {
  return "ChatRead";
});
$c_Lapp_api_GeneralPracticeAppUpdate$ChatRead$.prototype.fromProduct__s_Product__Lapp_api_GeneralPracticeAppUpdate$ChatRead = (function(x$0) {
  var id$1 = x$0.productElement__I__O(0);
  return new $j_app$002eapi$002e$002dGeneral$002dPractice$002dApp$002dUpdate$0024$002dChat$002dRead.$c_Lapp_api_GeneralPracticeAppUpdate$ChatRead(id$1);
});
$c_Lapp_api_GeneralPracticeAppUpdate$ChatRead$.prototype.fromProduct__s_Product__O = (function(p) {
  return this.fromProduct__s_Product__Lapp_api_GeneralPracticeAppUpdate$ChatRead(p);
});
var $d_Lapp_api_GeneralPracticeAppUpdate$ChatRead$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_api_GeneralPracticeAppUpdate$ChatRead$, "app.api.GeneralPracticeAppUpdate$ChatRead$", ({
  Lapp_api_GeneralPracticeAppUpdate$ChatRead$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
}));
export { $d_Lapp_api_GeneralPracticeAppUpdate$ChatRead$ as $d_Lapp_api_GeneralPracticeAppUpdate$ChatRead$ };
var $n_Lapp_api_GeneralPracticeAppUpdate$ChatRead$;
function $m_Lapp_api_GeneralPracticeAppUpdate$ChatRead$() {
  if ((!$n_Lapp_api_GeneralPracticeAppUpdate$ChatRead$)) {
    $n_Lapp_api_GeneralPracticeAppUpdate$ChatRead$ = new $c_Lapp_api_GeneralPracticeAppUpdate$ChatRead$();
  }
  return $n_Lapp_api_GeneralPracticeAppUpdate$ChatRead$;
}
export { $m_Lapp_api_GeneralPracticeAppUpdate$ChatRead$ as $m_Lapp_api_GeneralPracticeAppUpdate$ChatRead$ };
//# sourceMappingURL=app.api.-General-Practice-App-Update$-Chat-Read$.js.map
